const _temp0 = require("./Big Meadows Brochure.png");
const _temp1 = require("./Bus Tour Group.png");
const _temp2 = require("./Cars at Overlook.png");
const _temp3 = require("./Couple at Scenic Overlook.png");
const _temp4 = require("./Hogwallow Flats Overlook.png");
const _temp5 = require("./Johnson Civil Rights Act.png");
const _temp6 = require("./Lewis Mountain Cabin.png");
const _temp7 = require("./Map of Segregated Areas.png");
const _temp8 = require("./Martin Luther King Jr and Mathew Ahmann Civil Rights March.png");
const _temp9 = require("./Outdoor Film Watching.png");
const _temp10 = require("./People Outside at Shenandoah.png");
const _temp11 = require("./Protests.png");
const _temp12 = require("./School Integration.png");
const _temp13 = require("./Shenandoah in 1939 Panorama.png");
const _temp14 = require("./Shenandoah Mountain Overlook with Cars.png");
const _temp15 = require("./Skyline Drive Sign 1963.png");
const _temp16 = require("./Tourists at Hemlock Springs Overlook.png");
module.exports = {
  "Big Meadows Brochure": _temp0,
  "Bus Tour Group": _temp1,
  "Cars at Overlook": _temp2,
  "Couple at Scenic Overlook": _temp3,
  "Hogwallow Flats Overlook": _temp4,
  "Johnson Civil Rights Act": _temp5,
  "Lewis Mountain Cabin": _temp6,
  "Map of Segregated Areas": _temp7,
  "Martin Luther King Jr and Mathew Ahmann Civil Rights March": _temp8,
  "Outdoor Film Watching": _temp9,
  "People Outside at Shenandoah": _temp10,
  "Protests": _temp11,
  "School Integration": _temp12,
  "Shenandoah in 1939 Panorama": _temp13,
  "Shenandoah Mountain Overlook with Cars": _temp14,
  "Skyline Drive Sign 1963": _temp15,
  "Tourists at Hemlock Springs Overlook": _temp16
}